// extracted by mini-css-extract-plugin
export default {"container":"Switch_component_container__+HDIr","select":"Switch_component_select__gcYfM"};